import type React from 'react';

import { useAvailablePeriod } from '@src/entities/available-periods';

type Props = {
	id: number;
};

export const AvailablePeriodCost: React.FC<Props> = ({ id }) => {
	const { availablePeriod } = useAvailablePeriod(id);

	return <>{availablePeriod && `${availablePeriod.price / 100} ₽`}</>;
};
